import React, { createContext } from 'react';
import styled from 'styled-components';

import MenuButton from './MenuButton';
import MiddleTextConsole from './MiddleTextConsole';

const Container = styled.div`
  display: grid;
  grid-template-columns: 20% auto 20%;
  grid-template-rows: 83% 10%;
  height: 100%;
  font-size: 15px;
`;
const LeftConsolePanel = styled.div`
  display: grid;
`;
const MiddleConsolePanel = styled.div`
  background: white;
`;
const RightConsolePanel = styled.div`
  display: grid;
`;
const BottomConsolePanel = styled.div`
  grid-column: 1/4;
  display: grid;
  grid-auto-flow: column;
`;

export interface MenuItem {
  label?: string;
  type?:
    | 'NavigationButtonPrev'
    | 'ListButton'
    | 'Button'
    | 'ToggleButton'
    | 'NavigationButtonNext';
  attributes?: {
    value?: string;
    disabled?: boolean;
    options?: Array<string>;
  };
  index: number;
}

export type ButtonPositionType = {
  position: 'LeftPanel' | 'RightPanel' | 'BottomPanel';
};
export const ButtonPosition = {
  LeftPanel: 'LeftPanel',
  RightPanel: 'RightPanel',
  BottomPanel: 'BottomPanel',
};
export const ButtonPositionContext = createContext<Array<string>>([
  ButtonPosition.LeftPanel,
]);

const Console = ({ menu = [] }: { menu: Array<MenuItem> }) => {
  return (
    <Container>
      <ButtonPositionContext.Provider value={[ButtonPosition.LeftPanel]}>
        <LeftConsolePanel>
          {menu.slice(0, 5).map((menuItem) => (
            <MenuButton
              buttonIdentifier={menuItem.index}
              key={menuItem.label}
              item={menuItem}
            />
          ))}
        </LeftConsolePanel>
      </ButtonPositionContext.Provider>

      <MiddleConsolePanel>
        <MiddleTextConsole />
      </MiddleConsolePanel>
      <RightConsolePanel>
        <ButtonPositionContext.Provider value={[ButtonPosition.RightPanel]}>
          {menu
            .slice(10, 15)
            .reverse()
            .map((menuItem) => (
              <MenuButton
                buttonIdentifier={menuItem.index}
                key={menuItem.label}
                item={menuItem}
              />
            ))}
        </ButtonPositionContext.Provider>
      </RightConsolePanel>
      <BottomConsolePanel>
        <ButtonPositionContext.Provider
          value={[ButtonPosition.BottomPanel, ButtonPosition.LeftPanel]}
        >
          <MenuButton buttonIdentifier="6" item={menu[5]} />
        </ButtonPositionContext.Provider>
        <ButtonPositionContext.Provider value={[ButtonPosition.BottomPanel]}>
          {menu.slice(6, 9).map((menuItem) => (
            <MenuButton
              buttonIdentifier={menuItem.index}
              key={menuItem.label}
              item={menuItem}
            />
          ))}
        </ButtonPositionContext.Provider>
        <ButtonPositionContext.Provider
          value={[ButtonPosition.BottomPanel, ButtonPosition.RightPanel]}
        >
          <MenuButton buttonIdentifier="10" item={menu[9]} />
        </ButtonPositionContext.Provider>
      </BottomConsolePanel>
    </Container>
  );
};

export default Console;
